// ============================================================
// Cart Drawer + Universal Add-to-Cart Handler
// Merge logic now runs in TWO places: inside the drawer, and
// directly on the real /cart page — so bundles stay merged no
// matter how a customer arrives at their cart.
// ============================================================

var CartDrawer = {
  el: null,
  body: null,
  footer: null,

  init: function () {
    this.el = document.getElementById('cart-drawer');
    this.body = document.getElementById('cart-drawer-body');
    this.footer = document.getElementById('cart-drawer-footer');
    if (!this.el) return;

    var overlay = document.getElementById('cart-drawer-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');
    var cartIcon = document.getElementById('cart-icon-link');

    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        CartDrawer.refresh();
        CartDrawer.open();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') CartDrawer.close();
    });

    // Handle "Remove" links on NON-bundle items, wherever they
    // appear — inside the drawer, or on the real /cart page.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.cart-remove');
      if (!link) return;
      var insideDrawer = CartDrawer.body && CartDrawer.body.contains(link);
      var onRealPage = !insideDrawer && link.closest('.cart-list');
      if (!insideDrawer && !onRealPage) return;

      e.preventDefault();
      var jsUrl = link.href.replace('/cart/change', '/cart/change.js');
      fetch(jsUrl).then(function () {
        if (insideDrawer) {
          CartDrawer.refresh();
        } else {
          window.location.reload();
        }
      });
    });
  },

  open: function () {
    if (this.el) this.el.setAttribute('aria-hidden', 'false');
  },

  close: function () {
    if (this.el) this.el.setAttribute('aria-hidden', 'true');
  },

  updateHeaderCount: function (count) {
    var cartIcon = document.getElementById('cart-icon-link');
    if (!cartIcon) return;
    var countEl = cartIcon.querySelector('.cart-count');
    if (count > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'cart-count';
        cartIcon.appendChild(countEl);
      }
      countEl.textContent = '(' + count + ')';
    } else if (countEl) {
      countEl.remove();
    }
  },

  refresh: function () {
    var self = this;
    var pageFetch = fetch('/cart').then(function (res) { return res.text(); });
    var countFetch = fetch('/cart.js').then(function (res) { return res.json(); });

    return Promise.all([pageFetch, countFetch]).then(function (results) {
      var html = results[0];
      var cart = results[1];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var mainContent = doc.querySelector('.main-content');
      if (mainContent && self.body) {
        self.body.innerHTML = mainContent.innerHTML;
        mergeBundleRows(cart.items, self.body, false);
        promoteFooterContent(self.body, self.footer);
      }
      self.updateHeaderCount(cart.item_count);
    }).catch(function (err) {
      console.error('Cart refresh failed', err);
    });
  }
};

// ============================================================
// Move subtotal + checkout button into the fixed footer (drawer only)
// ============================================================

function promoteFooterContent(body, footer) {
  if (!footer) return;
  footer.innerHTML = '';

  var subtotalEl = body.querySelector('form#cartform .h2');
  var checkoutBtn = body.querySelector('form#cartform button[name="checkout"]');

  if (subtotalEl) footer.appendChild(subtotalEl);
  if (checkoutBtn) {
    checkoutBtn.setAttribute('form', 'cartform');
    footer.appendChild(checkoutBtn);
  }
}

// ============================================================
// Merge Top/Bottom bundle pairs into one combined cart row.
// Works on any container passed in — the drawer's body, OR the
// real /cart page itself.
// ============================================================

function money(cents) {
  return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function changeBundleQty(topKey, bottomKey, newQty, reloadOnChange) {
  Promise.all([
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: topKey, quantity: newQty })
    }),
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: bottomKey, quantity: newQty })
    })
  ]).then(function () {
    if (reloadOnChange) {
      window.location.reload();
    } else {
      CartDrawer.refresh();
    }
  });
}

// ============================================================
// Fetch the mother product's own image (cached per handle) so
// the merged row shows the real "Set" photo, not the Top's.
// ============================================================

var motherImageCache = {};

function getMotherImage(handle) {
  if (motherImageCache[handle]) return motherImageCache[handle];

  var promise = fetch('/products/' + handle + '.js')
    .then(function (res) { return res.json(); })
    .then(function (product) { return product.featured_image || null; })
    .catch(function () { return null; });

  motherImageCache[handle] = promise;
  return promise;
}

function mergeBundleRows(cartItems, root, reloadOnChange) {
  root = root || (CartDrawer && CartDrawer.body);
  if (!root) return;
  var rows = root.querySelectorAll('.cart-list .item');
  if (!rows.length || !cartItems || !cartItems.length) return;

  var groups = {};
  cartItems.forEach(function (item, i) {
    var bundleHandle = item.properties && item.properties._bundle;
    if (!bundleHandle) return;
    var groupKey = bundleHandle + '|' + item.variant_title;
    if (!groups[groupKey]) groups[groupKey] = [];
    groups[groupKey].push({ item: item, row: rows[i] });
  });

  Object.keys(groups).forEach(function (groupKey) {
    var pair = groups[groupKey];
    if (pair.length !== 2) return;

    var topEntry = pair.filter(function (p) { return p.item.properties._bundle_role === 'Top'; })[0];
    var bottomEntry = pair.filter(function (p) { return p.item.properties._bundle_role === 'Bottom'; })[0];
    if (!topEntry || !bottomEntry || !topEntry.row || !bottomEntry.row) return;

    var primaryRow = topEntry.row;
    var secondaryRow = bottomEntry.row;

    secondaryRow.style.display = 'none';

    var setName = topEntry.item.product_title.replace(/\s*Top$/i, '');
    var bundleHandle = topEntry.item.properties._bundle;

    // Swap in the mother product's real image instead of the Top's.
    var imgEl = primaryRow.querySelector('.col-image img');
    if (imgEl && bundleHandle) {
      getMotherImage(bundleHandle).then(function (imageUrl) {
        if (imageUrl) {
          imgEl.src = imageUrl;
          imgEl.removeAttribute('srcset');
          imgEl.alt = setName + ' Set';
        }
      });
    }

    var descEl = primaryRow.querySelector('.col-desc .title');
    if (descEl) {
      descEl.innerHTML =
        '<a href="' + topEntry.item.url + '">' + setName + ' Set<br>' + topEntry.item.variant_title + '</a>' +
        '<div style="font-size:12px;opacity:0.7;margin-top:4px;">' +
        'Top: ' + money(topEntry.item.price) + ' &middot; Bottom: ' + money(bottomEntry.item.price) +
        '</div>';
    }

    var priceEl = primaryRow.querySelector('.col-price');
    if (priceEl) {
      priceEl.innerHTML = '<div class="theme-money">' + money(topEntry.item.price + bottomEntry.item.price) + '</div>';
    }

    var totalEl = primaryRow.querySelector('.col-total');
    if (totalEl) {
      totalEl.innerHTML = '<div class="theme-money">' + money(topEntry.item.final_line_price + bottomEntry.item.final_line_price) + '</div>';
    }

    var qtyEl = primaryRow.querySelector('.col-quantity');
    if (qtyEl) {
      var qty = topEntry.item.quantity;
      qtyEl.innerHTML =
        '<div class="qty-selector">' +
          '<button type="button" class="qty-btn minus-btn cart-drawer-set-minus" data-direction="-">-</button>' +
          '<input class="input quantity" type="number" readonly value="' + qty + '">' +
          '<button type="button" class="qty-btn plus-btn cart-drawer-set-plus" data-direction="+">+</button>' +
        '</div>' +
        '<div style="margin-top:6px;"><a href="#" class="cart-drawer-set-remove">Remove</a></div>';
      qtyEl.querySelector('.cart-drawer-set-plus').addEventListener('click', function () {
        changeBundleQty(topEntry.item.key, bottomEntry.item.key, qty + 1, reloadOnChange);
      });
      qtyEl.querySelector('.cart-drawer-set-minus').addEventListener('click', function () {
        changeBundleQty(topEntry.item.key, bottomEntry.item.key, Math.max(0, qty - 1), reloadOnChange);
      });
      qtyEl.querySelector('.cart-drawer-set-remove').addEventListener('click', function (e) {
        e.preventDefault();
        changeBundleQty(topEntry.item.key, bottomEntry.item.key, 0, reloadOnChange);
      });
    }
  });
}

// ============================================================
// Merge on the REAL /cart page (not just inside the drawer)
// ============================================================

function initRealCartPage() {
  var path = window.location.pathname.replace(/\/$/, '');
  var isCartPage = path === '/cart' || path.endsWith('/cart');
  if (!isCartPage) return;

  var cartListEls = document.querySelectorAll('.cart-list');
  var realCartList = null;
  cartListEls.forEach(function (el) {
    if (!el.closest('#cart-drawer')) realCartList = el;
  });
  if (!realCartList) return;

  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      mergeBundleRows(cart.items, document, true);
    })
    .catch(function (err) {
      console.error('Real cart page merge failed', err);
    });
}

// ============================================================
// Bundle detection for Add-to-Cart
// ============================================================

var bundleCache = {};

function getBundleForHandle(handle) {
  if (bundleCache[handle]) return bundleCache[handle];

  var promise = Promise.all([
    fetch('/products/' + handle + '-top.js'),
    fetch('/products/' + handle + '-bottom.js')
  ]).then(function (results) {
    var topRes = results[0];
    var bottomRes = results[1];
    if (!topRes.ok || !bottomRes.ok) return null;
    return Promise.all([topRes.json(), bottomRes.json()]).then(function (data) {
      var topProduct = data[0];
      var bottomProduct = data[1];
      var topByLabel = {};
      topProduct.variants.forEach(function (v) { topByLabel[v.title] = v.id; });
      var bottomByLabel = {};
      bottomProduct.variants.forEach(function (v) { bottomByLabel[v.title] = v.id; });
      return { topByLabel: topByLabel, bottomByLabel: bottomByLabel };
    });
  }).catch(function () { return null; });

  bundleCache[handle] = promise;
  return promise;
}

// ============================================================
// Universal Add-to-Cart interception
// ============================================================

function initAddToCart() {
  var forms = document.querySelectorAll('form[action="/cart/add"]');

  forms.forEach(function (form) {
    var idField = form.querySelector('[name="id"]');
    var submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    if (!idField || !submitBtn) return;
    if (form.dataset.cartBound) return;
    form.dataset.cartBound = 'true';

    var productHandle = form.dataset.productHandle || window.__bundleCheckHandle;
    var productId = form.dataset.productId || window.__bundleCheckProductId;
    var staticVariantTitle = form.dataset.variantTitle || null;

    var freshBtn = submitBtn.cloneNode(true);
    submitBtn.parentNode.replaceChild(freshBtn, submitBtn);
    freshBtn.type = 'button';

    freshBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      freshBtn.disabled = true;

      var selectedVariantId = idField.value;
      var ageLabel = staticVariantTitle;

      if (productId) {
        var jsonEl = document.getElementById('ProductJson-' + productId);
        if (jsonEl) {
          try {
            var currentProduct = JSON.parse(jsonEl.textContent);
            var match = currentProduct.variants.find(function (v) {
              return String(v.id) === String(selectedVariantId);
            });
            if (match) ageLabel = match.title;
          } catch (err) { /* fall back to staticVariantTitle */ }
        }
      }

      var items;
      var bundle = productHandle ? await getBundleForHandle(productHandle) : null;

      if (bundle && ageLabel && bundle.topByLabel[ageLabel] && bundle.bottomByLabel[ageLabel]) {
        items = [
          { id: bundle.topByLabel[ageLabel], quantity: 1, properties: { _bundle: productHandle, _bundle_role: 'Top' } },
          { id: bundle.bottomByLabel[ageLabel], quantity: 1, properties: { _bundle: productHandle, _bundle_role: 'Bottom' } }
        ];
      } else {
        items = [{ id: selectedVariantId, quantity: 1 }];
      }

      try {
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!addRes.ok) throw new Error('Add to cart failed');

        await CartDrawer.refresh();
        CartDrawer.open();
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        freshBtn.disabled = false;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  CartDrawer.init();
  initAddToCart();
  initRealCartPage();
});
